import Image from 'next/image';
import { ComponentProps } from 'react';
import { useGlobal } from '@/utils/useGlobal';
type NextImageProps = Omit<ComponentProps<typeof Image>, ''> & {
    webpSrc?: ComponentProps<typeof Image>['src'];
    width?: ComponentProps<typeof Image>['width'];
    height?: ComponentProps<typeof Image>['height'];
    alt: ComponentProps<typeof Image>['alt'];
    placeholder?: ComponentProps<typeof Image>['placeholder']; // 'empty' | 'blur' | 'data: image/...'
    quality?: ComponentProps<typeof Image>['quality']; // quality number 1-100  default 75
    priority?: ComponentProps<typeof Image>['priority']; // priority true | false
    loader?: ComponentProps<typeof Image>['loader'];
};
/**
 * @props webpSrc - - 图片 webp地址
 * @props 其它 props - - 看next/image: https://nextjs.org/docs/api-reference/next/image
 * @returns
 */
export default function NextImage({
    src,
    webpSrc = src,
    width,
    height,
    loader,
    loading,
    priority = true,
    quality,
    alt = '',
    placeholder,
    ...props
}: NextImageProps) {
    const { isSupportWebp } = useGlobal();
    const finalySrc = isSupportWebp ? webpSrc : src;
    // loader example
    // const imageLoader = ({ src, width, quality }) => {
    //     return `https://example.com/${src}?w=${width}&q=${quality || 75}`;
    // };

    return (
        <>
            {width && height ? (
                <div
                    className="ef-pic"
                    style={{ width: typeof width === 'number' ? `${width}px` : width, height: typeof height === 'number' ? `${height}px` : height }}
                >
                    <Image
                        unoptimized // the source image will be served as-is instead of changing quality, size, or format. true | false
                        loader={loader}
                        loading={priority ? 'eager' : loading || 'lazy'} // lazy | eager, eager 立即加载图片，但会损害性能，配合使用priority
                        src={finalySrc}
                        width={width}
                        height={height}
                        fill={false}
                        // layout="fill"    // layout has already been removed in nextjs v13.0.0 version => fill
                        priority={priority || false} // 建议KV图使用
                        quality={quality || 75}
                        alt={alt}
                        placeholder={placeholder || 'empty'}
                        {...props}
                    />
                </div>
            ) : (
                <div className="ef-pic">
                    <Image
                        unoptimized // the source image will be served as-is instead of changing quality, size, or format. true | false
                        loader={loader}
                        loading={priority ? 'eager' : loading || 'lazy'} // lazy | eager, eager 立即加载图片，但会损害性能，配合使用priority
                        src={finalySrc}
                        fill={true}
                        // layout="fill"    // layout has already been removed in nextjs v13.0.0 version => fill
                        priority={priority || false} // 建议KV图使用
                        quality={quality || 75}
                        alt={alt}
                        placeholder={placeholder || 'empty'}
                        {...props}
                    />
                </div>
            )}
        </>
    );
}
